import React, {useState} from 'react';
import {Table, Form, Row, Container} from 'react-bootstrap';
import {FaInfoCircle} from "react-icons/all";
import {formatCurrency} from "../data.js"

const SinglePaymentTable = (props) => {
    // eslint-disable-next-line
    const [singlePaymentData, setSinglePaymentData] = useState([
            {
                "vade": 1,
                "toplamTutari": formatCurrency(props.payAmount),
                "moId":"MO_01"
            }
        ]
    )
    const handleRowClick = (item) => {
        props.setSelectedInstallmentId(item.moId);
    };

    return (
        <Container style={{paddingTop:"5px" ,textAlignLast: "center"}}>
            <Row className="justify-content-end" style={{padding: 0, margin: 0}}>
                <Table striped bordered hover  style={{padding: 0, margin: 0}}>
                    <thead>
                    </thead>
                    <tbody>
                    {singlePaymentData.map((item, index) => (
                        <tr key={index} onClick={() => handleRowClick(item)}>
                            <td>
                                <Form.Check
                                    type="radio"
                                    name="selectedRow"
                                    checked={props.selectedInstallmentId === item.moId}
                                />
                            </td>
                            <td>Tek Çekim</td>
                            <td>{item.toplamTutari}</td>
                        </tr>
                    ))}
                    </tbody>
                </Table>
                <div style={{color: "#e80000", fontWeight: "bold", fontSize: "x-small", paddingLeft: "16px"}}>
                    <FaInfoCircle style={{color: 'orange', marginTop: '-2px', scale:'1.5'}}/>
                    <span style={{color: 'black', fontStyle: 'italic'}}> KDV Dahil Fatura Tutarı</span>
                </div>
            </Row>
        </Container>
    );
};

export default SinglePaymentTable;
